import React from "react";
import { Typography } from "@mui/material";
import { colors } from "../../theme/theme";

export const CustomInputLabel = ({ text, required = false }) => (
  <Typography
    sx={{
      fontFamily: "Inter-Medium",
      fontSize: "15px",
      color: colors.textColor,
      mb: 1,
    }}
  >
    {text}
    {required && (
      <Typography
        sx={{
          color: colors.primary,
          fontFamily: "Inter-Medium",
          fontSize: "15px",
        }}
        component={"span"}
      >
        *
      </Typography>
    )}
  </Typography>
);
